import React from "react";
import { Type, Hash, FileText, CheckCircle2 } from "lucide-react";
import { FormInput, FormSelect, FormTextarea } from "./SharedFormComponents";

export const RegisteredTypeForm = ({ form, errors, handleInputChange }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 animate-in fade-in slide-in-from-bottom-2 duration-300">
      <FormInput
        icon={<Type size={14} />}
        label="Type Name"
        required
        field="registeredTypeName"
        value={form.registeredTypeName}
        onChange={handleInputChange}
        error={errors.registeredTypeName}
        placeholder="Enter type name"
      />
      <FormInput
        icon={<Hash size={14} />}
        label="Type Code"
        field="registeredTypeCode"
        value={form.registeredTypeCode}
        onChange={handleInputChange}
        error={errors.registeredTypeCode}
        placeholder="e.g. TYPE-001"
      />
      <div className="md:col-span-2">
        <FormTextarea
          icon={<FileText size={14} />}
          label="Description"
          field="description"
          value={form.description}
          onChange={handleInputChange}
          error={errors.description}
          placeholder="Type details..."
        />
      </div>
      <div className="md:col-span-2">
        <FormSelect
          icon={<CheckCircle2 size={14} />}
          label="Status"
          required
          field="status"
          options={[
            { value: "ACTIVE", label: "Active" },
            { value: "INACTIVE", label: "Inactive" },
          ]}
          value={form.status || "ACTIVE"}
          onChange={handleInputChange}
          error={errors.status}
        />
      </div>
    </div>
  );
};
